import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'
import Recruit, {IRecruit} from '@/models/Recruit'
import {IMedium, Medium} from '@/models/Medium'

export interface IRecommend extends IModelBase {
  name: string
  description?: string
  active: boolean
  medium: IMedium
  recruits?: Array<IRecruit>
}

export default class Recommend extends ModelBase {
  name = ''
  description?: string
  active: boolean
  medium?: Medium
  recruits: Array<Recruit> = []

  constructor(defaults?: IRecommend) {
    super(defaults)
    if (defaults) {
      this.name = defaults.name
      this.description = defaults.description
      this.active = defaults.active
      this.medium = defaults.medium
      this.recruits = defaults.recruits?.map(r => new Recruit(r)) || []
    }
  }

  toParams(): KeyPair {
    return {
      name: this.name,
      description: this.description,
      active: this.active,
      medium_id: this.medium.id,
      recruit_ids: this.recruits.map(r => r.id),
    }
  }
}